<script lang="ts">
  import { CirclePlus, CircleMinus } from "lucide-svelte"

  interface Props {
    expanded: boolean
    data: Record<string, any>
    class?: string
  }

  let { expanded = $bindable(false), data, class: css }: Props = $props()
</script>

<button
  class={["relative rounded-full bg-white w-5 h-5 ml-0.5 -mt-0.5", css || ""]}
  onclick={() => {
    expanded = !expanded
  }}
  data-name={data?.name}
  data-expanded={expanded}
  type="button"
>
  {#if expanded}
    <CircleMinus class="{data?.class} size-5 cursor-pointer" />
  {:else}
    <CirclePlus class="{data?.class} size-5 cursor-pointer" />
  {/if}
</button>
